
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-rich-text-v1',
    templateUrl: './view-rich-text-v1.component.html'
})
export class ViewRichTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;

    ngOnInit(): void {
    }
}
